import { render } from "./dpp-hotleadbutton.vue?vue&type=template&id=636817aa"
import script from "./dpp-hotleadbutton.js?vue&type=script&lang=js"
export * from "./dpp-hotleadbutton.js?vue&type=script&lang=js"

import "./dpp-hotleadbutton.vue?vue&type=style&index=0&id=636817aa&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__